import { render, staticRenderFns } from "./TreatmentFilters.vue?vue&type=template&id=075184f2&scoped=true"
import script from "./TreatmentFilters.vue?vue&type=script&lang=js"
export * from "./TreatmentFilters.vue?vue&type=script&lang=js"
import style0 from "./TreatmentFilters.vue?vue&type=style&index=0&id=075184f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075184f2",
  null
  
)

export default component.exports